import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'UserEdit',
  data: function data() {
    return {
      roleList: [],
      form: {
        id: null,
        name: '',
        userName: '',
        passWord: '',
        roleList: []
      },
      rules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        userName: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'blur'
        }],
        roleList: [{
          required: true,
          message: '请分配角色',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.id = null;
      this.form.userName = null;
      this.form.name = null;
      this.form.passWord = null;
      this.roleList = [];
      this.initRolesData();
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.id = data.id;
      this.form.name = data.name;
      this.form.userName = data.userName;
      this.form.roleList = [];
      var thiz = this;
      data.roleList.forEach(function (role) {
        thiz.form.roleList.push(role.id);
      });
      this.initRolesData();
    },
    updateApi: function updateApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var roles;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              roles = [];
              _this.form.roleList.forEach(function (role) {
                var par = {
                  id: role
                };
                roles.push(par);
              });
              _this.form.roleList = roles;
              _context.n = 1;
              return api.UPDATE_USER(_this.form);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    saveApi: function saveApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var roles;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              roles = [];
              _this2.form.roleList.forEach(function (role) {
                var par = {
                  id: role
                };
                roles.push(par);
              });
              _this2.form.roleList = roles;
              _context2.n = 1;
              return api.SAVE_USER(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this3.form.id != null) {
            _this3.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this3.updateApi();
            }).catch(function () {
              _this3.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this3.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    initRolesData: function initRolesData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res, list;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {};
              _context3.n = 1;
              return api.GET_ROLE_LIST(par);
            case 1:
              res = _context3.v;
              list = res.body;
              list.forEach(function (role) {
                role.checked = false;
              });
              if (_this4.roleList.length > 0) {
                _this4.form.roleList.forEach(function (role) {
                  list.forEach(function (role2) {
                    if (role === role2.id) {
                      role2.checked = true;
                    }
                  });
                });
              }
              _this4.roleList = list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};